






























































import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalResowing from './ModalResowing.vue';
import AddResowingBtn from './AddResowingBtn.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalCompanyHarvest from './ModalCompanyHarvest.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { dateFormat } from 'highcharts';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalResowing,
        AddResowingBtn,
        DeleteConfirmation
    }
})
export default class ForcePeriodsSowing extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    @Prop({default: -1}) ranchId: number;

    @Prop({
        default() {
            return [];
        }
    })
    selectedWorkSegments: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    forcedPeriods: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    vehiclesOptions: Array<object>;
    @Prop() vehicleID: number | null;
    patchData: object | null = null;
    visibleModalAddResowing: boolean = false;
    periodToDelete: object | null = null;
    tableHeaders: Array<object> = [];

    get getHeaders() {
        let tableHeaders: Array<object> = [
            {
                text: 'Fecha Inicio',
                value: 'start_date',
                formatter: this.dateFormatter,
                sortable: true
            },
            {
                text: 'Fecha Fin',
                value: 'end_date',
                formatter: this.dateFormatter,
                sortable: true
            },
            {
                text: 'Acciones',
                value: 'actions',
                sortable: true,
                width: '100px'
            }
        ];

        if (this.vehicleID == -1) {
            tableHeaders.unshift({
                text: 'Vehículo',
                value: 'vehicle',
                align: 'center',
                sortable: true
            });
        }

        return tableHeaders;
    }

    @Emit()
    updateSowingRanchLayers() {}

    @Emit()
    viewAllIgnoredPeriods() {}
    
    @Emit()
    updateResowingPeriodsList(newPeriodsList) {}

    // @Emit()
    // reloadModalViewAll(){}

    editSelectedPeriod(item) {
        this.patchData = item;
        this.visibilityModalAddResowing(true);
    }

    deleteSelectedPeriod(item) {
        this.periodToDelete = item;
        this.showDeleteConfirmationDialog(
            'Eliminar período de Resiembra',
            '¿Está seguro que desea eliminar este período'
        );
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.deletePeriod();
        } else {
            this.confirmationDelete = false;
        }
    }

    deletePeriod() {
        let self = this;
        if (this.periodToDelete !== null) {
            this.loadingIgnoredPeriods = true;
            InsuranceServices.deleteResownPolygon(this.periodToDelete['id'])
                .then(response => {
                    this.loadingIgnoredPeriods = false;
                    this.$_successLoadingDialog({
                        response: response,
                        alternative_msg: 'Período eliminado con éxito'
                    });
                    this.updateResowingPeriodsList(removeItemsFromList(self.forcedPeriods, [self.periodToDelete], 'id'));
                    
                })
                .catch(error => {
                    this.loadingIgnoredPeriods = false;
                    this.$_catchLoadingDialog({
                        response: error.response.data || {},
                        alternative_msg: 'No se pudo eliminar el período de resiembra'
                    });
                });
        }
    }


    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    visibilityModalAddResowing(value) {
        this.visibleModalAddResowing = value;
    }

    closeModalIgnorePeriod() {
        this.patchData = null;
        this.periodToDelete = null;
        this.visibilityModalAddResowing(false);
    }

    clickAddNewResowingPeriod() {
        this.patchData = null;
        this.periodToDelete = null;
        this.visibilityModalAddResowing(true);
    }
}
